import { ArrowRight, Phone, CalendarCheck } from "lucide-react";
import { APPLY_URL, BOOK_URL, PHONE_NUMBER, PHONE_TEL, HERO_IMAGE } from "@/lib/site";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMAGE}
          alt="Modern home exterior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2F6B]/95 via-[#0A2F6B]/85 to-[#0A2F6B]/55" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-28 md:pt-28 md:pb-40 lg:pt-32 lg:pb-48">
        <div className="max-w-3xl">
          <h1
            data-testid="hero-headline"
            className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.05] tracking-tight animate-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            Turn Your Home&rsquo;s Equity
            <span className="block text-[#F26A21] mt-2">Into Opportunity.</span>
          </h1>

          <p
            className="mt-6 md:mt-8 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl animate-fade-up"
            style={{ animationDelay: "0.2s" }}
          >
            A Home Equity Line of Credit (HELOC) may give you the flexibility to access
            the equity you&rsquo;ve built in your home &mdash; for renovations, debt consolidation,
            education, and life&rsquo;s major moments.
          </p>

          <div
            className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-up"
            style={{ animationDelay: "0.3s" }}
          >
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-apply-button"
              className="inline-flex items-center justify-center gap-2 bg-[#F26A21] hover:bg-[#D95A1A] text-white font-semibold text-base px-6 py-3.5 rounded-md shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
            >
              Apply Now
              <ArrowRight size={18} strokeWidth={2.5} />
            </a>

            <a
              href={BOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-book-button"
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-[#F1F5F9] text-[#0A2F6B] font-semibold text-base px-6 py-3.5 rounded-md shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
            >
              <CalendarCheck size={18} strokeWidth={2.5} />
              Book a Meeting
            </a>

            <a
              href="#contact"
              data-testid="hero-callback-button"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-base px-6 py-3.5 rounded-md transition-all duration-200"
            >
              Request a Callback
            </a>

            <a
              href={PHONE_TEL}
              data-testid="hero-phone-button"
              className="inline-flex items-center justify-center gap-2 text-white font-semibold text-base px-2 py-3.5 transition-all duration-200 hover:text-[#F26A21]"
            >
              <Phone size={18} strokeWidth={2.5} />
              <span className="tabular-nums">{PHONE_NUMBER}</span>
            </a>
          </div>

          <p
            className="mt-6 text-xs text-white/60 max-w-xl animate-fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            Equal Housing Opportunity. All applications subject to underwriting guidelines,
            product/program availability, creditworthiness, loan amount, and property type.
          </p>
        </div>
      </div>
    </section>
  );
}
